import api from './api';

/**
 * Service for hotel-related API calls
 */

/**
 * Fetch all hotels
 * @param {Object} filters - Optional filters for the hotels
 * @returns {Promise<Array>} Array of hotel data
 */
export const fetchAllHotels = async (filters = {}) => {
  try {
    const response = await api.get('/hotels', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Error fetching hotels:', error);
    throw error;
  }
};

/**
 * Fetch a single hotel by ID
 * @param {string} hotelId - The ID of the hotel to fetch
 * @returns {Promise<Object>} Hotel data
 */
export const fetchHotelById = async (hotelId) => {
  try {
    const response = await api.get(`/hotels/${hotelId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching hotel ${hotelId}:`, error);
    throw error;
  }
};

/**
 * Fetch featured hotels
 * @param {number} limit - Maximum number of hotels to fetch
 * @returns {Promise<Array>} Array of featured hotel data
 */
export const fetchFeaturedHotels = async (limit = 6) => {
  try {
    const response = await api.get('/hotels/featured', { params: { limit } });
    return response.data;
  } catch (error) {
    console.error('Error fetching featured hotels:', error);
    throw error;
  }
};

/**
 * Create a new hotel
 * @param {Object} hotelData - The hotel data to create
 * @returns {Promise<Object>} Created hotel data
 */
export const createHotel = async (hotelData) => {
  try {
    const response = await api.post('/hotels', hotelData);
    return response.data;
  } catch (error) {
    console.error('Error creating hotel:', error);
    throw error;
  }
};

/**
 * Update an existing hotel
 * @param {string} hotelId - The ID of the hotel to update
 * @param {Object} hotelData - The updated hotel data
 * @returns {Promise<Object>} Updated hotel data
 */
export const updateHotel = async (hotelId, hotelData) => {
  try {
    const response = await api.patch(`/hotels/${hotelId}`, hotelData);
    return response.data;
  } catch (error) {
    console.error(`Error updating hotel ${hotelId}:`, error);
    throw error;
  }
};

/**
 * Delete a hotel
 * @param {string} hotelId - The ID of the hotel to delete
 * @returns {Promise<Object>} Deletion result
 */
export const deleteHotel = async (hotelId) => {
  try {
    const response = await api.delete(`/hotels/${hotelId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting hotel ${hotelId}:`, error);
    throw error;
  }
};

